if (!customElements.get('final-sale-confirmation')) {
  class FinalSaleConfirmation extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.querySelector('[role="dialog"]');
      this.confirmButton = this.querySelector('[data-final-sale-confirm]');
      this.closeButtons = this.querySelectorAll('[data-final-sale-close]');
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleKeyup = this.handleKeyup.bind(this);
      this.confirmCheckout = this.confirmCheckout.bind(this);
      this.close = this.close.bind(this);
    }

    connectedCallback() {
      document.addEventListener('submit', this.handleSubmit, true);
      this.addEventListener('keyup', this.handleKeyup);
      this.confirmButton.addEventListener('click', this.confirmCheckout);
      this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.handleSubmit, true);
      this.removeEventListener('keyup', this.handleKeyup);
      this.confirmButton.removeEventListener('click', this.confirmCheckout);
      this.closeButtons.forEach((button) => button.removeEventListener('click', this.close));
    }

    handleSubmit(event) {
      const form = event.target;
      const submitter = event.submitter;

      if (!(form instanceof HTMLFormElement) || !submitter?.hasAttribute('data-final-sale-checkout')) return;

      if (this.bypassForm === form) {
        this.bypassForm = null;
        return;
      }

      if (!this.cartHasFinalSale(form)) return;

      event.preventDefault();
      this.pendingForm = form;
      this.pendingSubmitter = submitter;
      this.open(submitter);
    }

    cartHasFinalSale(form) {
      if (form.querySelector('[data-final-sale-item]')) return true;

      const notification = form.closest('cart-notification');
      return Boolean(notification?.querySelector('[data-final-sale-item]'));
    }

    open(trigger) {
      this.trigger = trigger;
      this.confirmButton.disabled = false;
      this.confirmButton.removeAttribute('aria-busy');
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      trapFocus(this, this.dialog);
    }

    close({ restoreFocus = true } = {}) {
      if (!this.hasAttribute('open')) return;

      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      removeTrapFocus();

      const cartDrawer = this.trigger?.closest('cart-drawer');
      if (restoreFocus && cartDrawer?.classList.contains('active')) {
        trapFocus(cartDrawer, this.trigger);
      } else if (restoreFocus && this.trigger) {
        this.trigger.focus();
      }

      if (!cartDrawer?.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden');
      }
    }

    handleKeyup(event) {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    }

    async confirmCheckout() {
      const form = this.pendingForm;
      const submitter = this.pendingSubmitter;
      if (!form || !submitter || this.confirmButton.disabled) return;

      this.confirmButton.disabled = true;
      this.confirmButton.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Final sale policy acknowledged': `Yes — ${new Date().toISOString()}`,
            },
          }),
        });

        if (!response.ok) throw new Error(`Cart update failed with status ${response.status}`);
      } catch (error) {
        console.warn('The Final Sale acknowledgement could not be saved.', error);
      }

      this.bypassForm = form;
      this.close({ restoreFocus: false });
      form.requestSubmit(submitter);
    }
  }

  customElements.define('final-sale-confirmation', FinalSaleConfirmation);
}
